import { Container, Row, Col } from '@geberit/gdds';

// styles
import styles from '../text-image.module.scss';

// types
import type { FullLayoutProps } from '..';

// utils
import { fullGridSize, contentHeadline, aboveHeadline, getFullGridSize } from '..';
import { buildSize, gridSizes } from 'utils/gridSize';
import { useGroup } from 'utils/hooks/use-group';
import { classNameBuilder } from 'utils/classNameBuilder';
import { useViewportName } from '../../../App/SizeProvider';

export function Full(props: Readonly<FullLayoutProps>) {
  const {
    image: Image,
    headline: Headline,
    caption: Caption,
    content: Content,
    link: Link,
    theme,
    mediaPosition,
  } = props;
  const viewport = useViewportName();
  const size = getFullGridSize(mediaPosition, viewport);
  const isGroup = useGroup();

  return (
    <Container maxContentWidth={buildSize(gridSizes[fullGridSize[theme]])}>
      <Row className={isGroup ? '' : styles.centeredCol}>
        {isGroup ? (
          <Col>
            {Headline && <Headline format={contentHeadline[theme]} />}
            {Image && <Image />}
            {Caption && <Caption />}
            {Content && <Content />}
          </Col>
        ) : (
          <>
            <Col size={[4, 8, 12]}>
              {Headline && <Headline aboveHeadline={aboveHeadline[theme]} />}
            </Col>
            {(Image || Caption) && (
              <Col
                size={[4, size, size || 12]}
                className={classNameBuilder(
                  styles.fullColMargin,
                  mediaPosition === 'full_large' && styles.fullWidth,
                )}
              >
                {Image && <Image />}
                {Caption && <Caption />}
              </Col>
            )}
            <Col size={[4, 8, 12]}>
              {Headline && <Headline className={styles.subline} format={contentHeadline[theme]} />}
              {Content && <Content />}
              {Link && <Link />}
            </Col>
          </>
        )}
      </Row>
    </Container>
  );
}
